import { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/category', label: '影视分类' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于我们' },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword('');
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 group" aria-label="玉女心经2 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-book-open-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black tracking-wide text-foreground-950">玉女心经2</span>
              <span className="mt-0.5 font-label text-[10px] tracking-[0.2em] text-foreground-500">YU NU XIN JING</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md font-label text-sm transition-colors cursor-pointer ${
                    isActive
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-primary-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={handleSearch} className="hidden lg:flex items-center gap-2">
            <div className="flex items-center gap-2 rounded-md border border-background-300/70 bg-background-100/80 px-3 py-2 focus-within:border-primary-400 transition-colors">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="text"
                placeholder="搜索影视 / 角色"
                className="w-44 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 outline-none"
              />
            </div>
            <button
              type="submit"
              className="rounded-md bg-accent-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-accent-600 cursor-pointer whitespace-nowrap"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 md:hidden cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 md:hidden">
          <div className="px-4 py-3 space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `block rounded-md px-4 py-3 font-label text-sm transition-colors ${
                    isActive ? 'bg-primary-100 text-primary-700 font-medium' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <form onSubmit={handleSearch} className="flex items-center gap-2 pt-2">
              <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300/70 bg-background-100/80 px-3 py-2">
                <i className="ri-search-line text-base text-foreground-500"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  type="text"
                  placeholder="搜索影视 / 角色"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 outline-none"
                />
              </div>
              <button
                type="submit"
                className="rounded-md bg-accent-500 px-4 py-2 font-label text-sm text-background-50 whitespace-nowrap cursor-pointer"
              >
                搜索
              </button>
            </form>
          </div>
        </div>
      )}
    </header>
  );
}